import createIcon from '../../createIcon';

/**
 * @component @name FormatQuote
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxN0g5TDExIDEzVjdINVYxM0g4TDYgMTdaTTE0IDE3SDE3TDE5IDEzVjdIMTNWMTNIMTZMMTQgMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatQuote = createIcon('FormatQuote', [
  ['path', { d: 'M6 17H9L11 13V7H5V13H8L6 17ZM14 17H17L19 13V7H13V13H16L14 17Z', key: 'ubh1vf' }],
]);

export default FormatQuote;
